import { Spinner, Stack } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { useAuth, useLayoutUtils } from '../../hooks';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const { isProfileLoading } = useAuth();
  const { innerHeight } = useLayoutUtils();

  return isProfileLoading ? (
    <Stack height={innerHeight} alignItems="center" justifyContent="center">
      <Spinner />
    </Stack>
  ) : (
    children
  );
};
